module.exports = __webpack_public_path__ + "img/IMG-20170613-WA0005.fd4af40d.jpg";